import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';
import Format from 'app/src/data/Format';

export default class UITooltip extends RetailModel {
  get defaults() {
    return {
      name: '',
    };
  }

  /**
   * Return the url for the Register endpoint
   */
  url() {
    return `${URLHelper.getAccountURL('/UITooltip')}.json`;
  }
}
